module.exports = __webpack_public_path__ + "media/artist.bd8473e3.mp4";